import { selectAllNodes } from './helpers';
const Masonry = require('masonry-layout');

export default function masonryBlock() {
  const grids = selectAllNodes('masonry-block__grid');

  const initMasonry = grid => {
    const gridItems = selectAllNodes('masonry-block__item', grid);

    const msnry = new Masonry(grid, {
      itemSelector: '.masonry-block__item',
      columnWidth: '.masonry-block__item',
      gutter: '.grid-gutter-sizer',
      percentPosition: true,
      visibleStyle: { opacity: 1 },
      hiddenStyle: { opacity: 0 }
    });
  };

  if (grids.length) grids.map(initMasonry);
}
